<template>
  <div ref="baseTableGroup" class="base-tableGroup" :style="styles" :class="classs">
    <!-- table 模块 全屏的时候隐藏 全屏取消的时候在出来  -->
    <BaseTable 
      ref="table" 
      :height="tableHeight" 
      v-bind="$attrs" 
      highlight-current-row 
      :cell-class-name="cellClassName" 
      :header-cell-class-name="cellClassName" 
      v-on="$listeners"
    />
    <!-- page 模块 -->
    <div v-if="showPage" class="page">
      <BasePagination
        :total="total"
        :page.sync="pageSync"
        :limit.sync="limit"
        @page="handlePageChange"
        @pagination="handlePageChange"
      />
    </div>
  </div>
</template>
<script>
import BaseTable from './index.vue'
import BasePagination from './BasePagination.vue'
export default {
  name: 'BaseTableGroup',
  components: {
    BaseTable,
    BasePagination,
  },
  provide () {
    return {
      baseTableGroupVm: this
    }
  },
  inheritAttrs: false,
  props: {
    /**
     * @description 分页总数
     */
    total: {
      type: Number,
      default: 0
    },
    pageSize: {
      type: Number,
      default: 100
    },
    page: {
      type: Number,
      default: 1
    },
    formatDate: {
      type: String,
      default: 'YYYY-MM-DD HH:mm:ss'
    },
    showPage: {
      type: Boolean,
      default: true
    },
    height: {
      type: [String, Number],
      default: ''
    },
    // 完全自定义高度
    // 是否计算高度赋值到 Table，如果是非常规搜索表格页，比如弹框里的表格不需要计算高度
    autoHeight: {
      type: Boolean,
      default: false
    },
    showOption: {
      type: Boolean,
      default: false
    },
    // 表格请求数据函数
    request: {
      type: Function,
      default: null
    },
    headerOptions: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      fullscreen: false,
      size: 'default'
    }
  },
  computed: {
    styles () {
      return {
        height: this.wrapperHeight,
        padding: (!this.fullscreen && this.device === 'mobile') ? '12px 0 ' : '0'
      }
    },
    classs () {
      return {
        fullscreen: this.fullscreen
      }
    },
    // 表格操作项andPage的高度
    otherHeight () {
      const tableHeaderHeight = (this.showOption || this.headerOptions.length !== 0) ? 52 : 0
      const pageHeight = 38
      return tableHeaderHeight + pageHeight
    },
    tableHeight () {
      if (this.height) return this.height
      if (!this.autoHeight) return null
      // 如果是移动端 高度有限 默认高度 100vh
      if (this.device === 'mobile') return '90vh'
      return `calc(100% - ${this.otherHeight}px)`
    },
    // 根元素高度
    wrapperHeight () {
      if (this.device === 'mobile') return '90vh'
      // 10px  是margin的高度
      return this.autoHeight ? `calc(100% - ${this.baseSearchHeight + 10}px )` : 'unset'
    },
    limit: {
      get () {
        return this.pageSize
      },
      set (value) {
        this.$emit('update:page', 1)
        this.$emit('update:pageSize', value)
      }
    },
    pageSync: {
      get () {
        return this.page
      },
      set (value) {
        this.$emit('update:page', value)
      }
    },
    /** 单元格 cell-class-name */
    cellClassName () {
      // 只有显示操作项的时候才需要自定义单元格padding
      if (this.showOption === false) return ''
      if (this.size === 'medium') return 'base-table-group-cell-medium'
      if (this.size === 'mini') return 'base-table-group-cell-mini'
      return ''
    }
  },
  watch: {
    // 当路由变动了 但是全屏是打开的 那么就关闭全屏
    $route () {
      if (this.fullscreen) this.fullscreen = false
    }
  },
  created () {
    const size = window.localStorage.getItem('tableSize')
    if (size && ['default', 'medium', 'mini'].includes(size)) {
      this.size = size
    }
  },
  methods: {
    onRefresh () {
      this.request && this.request()
    },
    /** * @description table 一页展示几条数据 change 事件 */
    handlePageSizeChange (pageSize) {
      this.$emit('on-page-size-change', pageSize)
    },
    /**
     * @description page change事件
     */
    handlePageChange (page) {
      // 暂时刷新事件和emit事件都调用
      this.onRefresh()
      this.$emit('pageChange', page)
    },
    tableDoLayout () {
      this.$refs.table && this.$refs.table.tableDoLayout()
    },
    clearSort(){
      this.$refs.table.clearSort()
    },
    // 调用 ref.table 的内置方法
    callBuiltInMethod (fn) {
      this.$refs.table.callBuiltInMethod(fn)
    }
  }
}
</script>
<style lang="scss" scoped>
.base-tableGroup {
  width: 100%;
  background-color: #ffffff;
}
 .page {
    width: 100%;
    height:30px;
    max-width: 100%;
    overflow:auto;
    margin: 6px 0;
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
  }
</style>
